"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Spinner = _interopRequireDefault(require("./Spinner"));

var _default = function _default() {
  var style = {
    width: '100%',
    height: '100%',
    opacity: '0.5',
    position: 'absolute',
    top: '0',
    background: '#333333',
    zIndex: 10
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null));
};

exports["default"] = _default;